import { registerMsgHandler } from "userful-chronos-app-common-js/dist/message/messageRegistery";
import {
    RESPOND_LIST_PASSPORTS,
    RESPOND_ADD_PASSPORT,
    RESPOND_UPDATE_PASSPORT,
    RESPOND_UPDATE_PASSPORT_WITH_OAUTH,
    RESPOND_REMOVE_PASSPORT,
    NOTIFY_PASSPORT_UPDATE,
    RESPOND_CODE_CHALLENGE,
    RESPOND_BASE_URL,
    RESPOND_ACCESS_TOKEN,
    RESPOND_SHEET_NAMES,
} from "userful-chronos-app-common-js/dist/message/messageTypeDefinitions/integration/excelMsgDefinitions";
import {
    ExcelPassport,
    ExcelPassportHeader,
    ExcelPassportID,
    ExcelPassportAuthCode,
    ExcelCodeChallenge,
    ExcelToken,
    ExcelSheetNamesResponse,
} from "userful-chronos-app-common-js/dist/models/integration/excel";
import integrationStore from "../integrationStore";
import { excelActions } from "../excelSlice";
import { registerErrorMsgHandlerByMsgDefinition } from "userful-chronos-app-common-js/dist/message/messageRegistery";

registerMsgHandler(RESPOND_LIST_PASSPORTS, (payload) => {
    console.debug("receive EXCEL RESPOND_LIST_PASSPORTS");
    const data = JSON.parse(payload) as ExcelPassport[];
    integrationStore.dispatch(excelActions.setPassports(data));
});

registerMsgHandler(RESPOND_ADD_PASSPORT, (payload) => {
    console.debug("receive RESPOND_ADD_PASSPORT");
    const data = JSON.parse(payload) as ExcelPassportHeader;
    integrationStore.dispatch(excelActions.changeLoadState("RENDER"));
    integrationStore.dispatch(excelActions.setOpenForm(false));
});

registerErrorMsgHandlerByMsgDefinition(RESPOND_ADD_PASSPORT, (data) => {
    integrationStore.dispatch(excelActions.changeLoadState("RENDER"));
});

registerMsgHandler(RESPOND_UPDATE_PASSPORT, (payload) => {
    console.debug("receive RESPOND_UPDATE_PASSPORT");
    const data = JSON.parse(payload) as ExcelPassportHeader;
    integrationStore.dispatch(excelActions.changeLoadState("RENDER"));
    integrationStore.dispatch(excelActions.setOpenForm(false));
});

registerErrorMsgHandlerByMsgDefinition(RESPOND_UPDATE_PASSPORT, (data) => {
    integrationStore.dispatch(excelActions.changeLoadState("RENDER"));
});

registerMsgHandler(RESPOND_UPDATE_PASSPORT_WITH_OAUTH, (payload) => {
    console.debug("receive RESPOND_UPDATE_PASSPORT_WITH_OAUTH");
    const data = JSON.parse(payload) as ExcelPassportHeader;
    integrationStore.dispatch(excelActions.changeLoadState("RENDER"));
    integrationStore.dispatch(excelActions.setOpenForm(false));
});

registerErrorMsgHandlerByMsgDefinition(RESPOND_UPDATE_PASSPORT_WITH_OAUTH, (data) => {
    integrationStore.dispatch(excelActions.changeLoadState("RENDER"));
});

registerMsgHandler(RESPOND_REMOVE_PASSPORT, (payload) => {
    console.debug("receive RESPOND_REMOVE_PASSPORT");
    const data = JSON.parse(payload) as ExcelPassportID;
    integrationStore.dispatch(excelActions.removePassport(data));
});

registerMsgHandler(NOTIFY_PASSPORT_UPDATE, (payload) => {
    console.debug("receive NOTIFY_PASSPORT_UPDATE");
    const data = JSON.parse(payload) as ExcelPassport;
    integrationStore.dispatch(excelActions.addOrUpdatePassport(data));
});

registerMsgHandler(RESPOND_CODE_CHALLENGE, (payload) => {
    console.debug("receive RESPOND_CODE_CHALLENGE");
    const data = JSON.parse(payload) as ExcelCodeChallenge;
    integrationStore.dispatch(excelActions.setCodeChallenge(data.codeChallenge));
});

registerMsgHandler(RESPOND_BASE_URL, (payload) => {
    console.debug("receive RESPOND_BASE_URL");
    const data = JSON.parse(payload) as string;
    integrationStore.dispatch(excelActions.setBaseURL(data));
});

registerMsgHandler(RESPOND_ACCESS_TOKEN, (payload) => {
    console.debug("receive RESPOND_ACCESS_TOKEN_GRAPH");
    const data = JSON.parse(payload) as ExcelToken;
    integrationStore.dispatch(excelActions.setAccessTokenGraph(data.accessTokenGraph));
    integrationStore.dispatch(excelActions.setAccessTokenExcel(data.accessTokenExcel));
});

registerMsgHandler(RESPOND_SHEET_NAMES, (payload) => {
    console.debug("receive RESPOND_SHEET_NAMES");
    try {
        const data = JSON.parse(payload) as ExcelSheetNamesResponse;
        integrationStore.dispatch(excelActions.setSheetNames(data.sheetNames));
    } catch (error) {
        console.error("Error parsing RESPOND_SHEET_NAMES payload:", error);
        integrationStore.dispatch(excelActions.setSheetNamesLoadState("ERROR"));
    }
});

registerErrorMsgHandlerByMsgDefinition(RESPOND_SHEET_NAMES, (data) => {
    console.error("Error received for RESPOND_SHEET_NAMES:", data);
    integrationStore.dispatch(excelActions.setSheetNamesLoadState("ERROR"));
});
